import { VCS_PROVIDERS_COLORED_ICONS, VCS_PROVIDERS_ICONS } from "constants/providerIcons";
import Icon from "ds/components/Icon";
import IconEmphasized from "ds/components/IconEmphasized";
import { VcsIntegration } from "types/generated";

type VCSProviderIconProps = {
  provider: VcsIntegration["provider"];
  tile?: boolean;
  isDefault?: boolean;
};

const VCSProviderIcon = ({ provider, tile, isDefault }: VCSProviderIconProps) => {
  return (
    (tile && (
      <IconEmphasized
        icon={VCS_PROVIDERS_COLORED_ICONS[provider]}
        color={isDefault ? "selected" : "gray"}
      />
    )) || <Icon src={VCS_PROVIDERS_ICONS[provider]} size={tile ? "large" : "default"} />
  );
};

export default VCSProviderIcon;
